import { AxonLockup } from "./AxonMark.js";
import { MARKETPLACE_URL, NPM_URL, NPM_SDK_URL } from "./Nav.js";

// Source repo is private (closed-source posture). The npm package
// pages are the canonical public surface — link there, never GitHub.
const NPM_MCP_URL = "https://www.npmjs.com/package/@axon-trading/mcp";
const NPM_CHANGELOG_URL = `${NPM_URL}?activeTab=versions`;

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="ax-footer">
      <div className="ax-footer-inner">
        <div className="ax-footer-left">
          <AxonLockup size={22} />
          <p className="ax-footer-tag">
            The non-custodial harness for agentic trading.<br />
            Perps · spot · lending. Built by Strykr Labs.
          </p>
        </div>

        <div className="ax-footer-links">
          <FooterCol
            title="Product"
            links={[
              ["Launch demo", "/app/"],
              ["Marketplace", MARKETPLACE_URL],
              ["npm · @axon-trading/cli", NPM_URL],
              ["npm · @axon-trading/sdk", NPM_SDK_URL],
            ]}
          />
          <FooterCol
            title="Resources"
            links={[
              ["Documentation", NPM_URL],
              ["Changelog", NPM_CHANGELOG_URL],
              ["npm · @axon-trading/mcp", NPM_MCP_URL],
              ["Strategies", MARKETPLACE_URL],
            ]}
          />
          <FooterCol
            title="Venues"
            links={[
              ["Hyperliquid", "https://hyperliquid.xyz"],
              ["Uniswap V3", "https://uniswap.org"],
              ["PancakeSwap V3", "https://pancakeswap.finance"],
              ["Aave V3", "https://aave.com"],
              ["GMX v2", "https://gmx.io"],
              ["Phoenix", "https://www.phoenix.trade"],
              ["Lighter", "https://lighter.xyz"],
            ]}
          />
        </div>
      </div>

      <div className="ax-footer-bottom">
        <div className="ax-footer-bottom-inner">
          <span className="ax-footer-copy">© {year} Strykr Labs. All rights reserved.</span>
          <span className="ax-footer-note">
            Not investment advice. Trading, lending, and onchain actions involve risk of loss.
          </span>
        </div>
      </div>

      <style>{`
        .ax-footer {
          padding: 56px 32px 0;
          background: var(--at-bg);
          border-top: 1px solid var(--at-hairline);
        }
        .ax-footer-inner {
          max-width: min(1800px, 92vw); margin: 0 auto;
          display: grid; grid-template-columns: 1fr 3fr;
          gap: clamp(32px, 4vw, 72px);
          padding-bottom: 48px;
        }
        @media (max-width: 820px) {
          .ax-footer-inner { grid-template-columns: 1fr; gap: 32px; }
          .ax-footer { padding: 40px 20px 0; }
        }
        .ax-footer-tag {
          font-family: var(--at-font-mono);
          font-size: 12px;
          line-height: 1.7;
          color: var(--at-muted);
          margin: 16px 0 0;
        }
        .ax-footer-links {
          display: grid; grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        @media (max-width: 820px) {
          .ax-footer-links { grid-template-columns: repeat(2, 1fr); gap: 32px; }
        }
        @media (max-width: 480px) {
          .ax-footer-links { grid-template-columns: 1fr; }
        }
        .ax-footer-bottom {
          border-top: 1px solid var(--at-hairline);
          padding: 20px 0;
        }
        .ax-footer-bottom-inner {
          max-width: 1280px;
          margin: 0 auto;
          display: flex; justify-content: space-between; gap: 16px;
          flex-wrap: wrap;
          font-family: var(--at-font-mono);
          font-size: 11px;
          color: var(--at-muted);
        }
      `}</style>
    </footer>
  );
}

function FooterCol({ title, links }: { title: string; links: [string, string][] }) {
  return (
    <div>
      <div className="ax-footer-col-title">{title}</div>
      <ul className="ax-footer-col-list">
        {links.map(([label, href]) => (
          <li key={label}>
            <a href={href} target="_blank" rel="noreferrer">{label}</a>
          </li>
        ))}
      </ul>
      <style>{`
        .ax-footer-col-title {
          font-family: var(--at-font-mono);
          font-size: 10px;
          letter-spacing: 0.3em;
          color: var(--at-muted);
          text-transform: uppercase;
          margin-bottom: 16px;
        }
        .ax-footer-col-list {
          list-style: none; margin: 0; padding: 0;
          display: flex; flex-direction: column; gap: 10px;
        }
        .ax-footer-col-list a {
          font-size: 13px;
          color: var(--at-fg-dim);
          transition: color var(--at-dur-fast) var(--at-ease);
        }
        .ax-footer-col-list a:hover { color: var(--at-fg); }
      `}</style>
    </div>
  );
}
